import axios from 'axios';

export const PROGRAMS = 'lms/courses';

export function getProgram(guid, params = {}) {
  return axios.get(`${PROGRAMS}/${guid}`, { params: { ...params, isEditorial: 1 } });
}

export function getPrograms(params) {
  return axios.get(PROGRAMS, { params });
}

export function createProgram(params) {
  return axios.post(PROGRAMS, params);
}

export function updateProgram(params) {
  return axios.put(`${PROGRAMS}/${params.guid}`, params);
}

export function deleteProgram(params = { guid: [] }) {
  return axios.delete(PROGRAMS, { data: params });
}

export function cloneProgram(params) {
  return axios.post('lms/courses-clone', params);
}

// ---------------------------------------------------
//  RELATED
// ---------------------------------------------------

export function getProgramsRelated(courseGuid, params = {}) {
  // ?pageSize=2&offset=0
  return axios.get(`${PROGRAMS}/${courseGuid}/related`, { params });
}

// ---------------------------------------------------
//  PROGRAM HOME TEMPLATE CRUD
// ---------------------------------------------------
export function getHomeTemplate(courseGuid) {
  return axios.get(`v3/home-templates/${courseGuid}`);
}

export function createHomeTemplate(params) {
  return axios.post('v3/home-templates', params);
}

export function updateHomeTemplate(templateId, params) {
  return axios.put(`v3/home-templates/${templateId}`, params);
}

export function patchHomeTemplate(templateId, params) {
  return axios.patch(`v3/home-templates/${templateId}`, params);
}

export function cloneHomeTemplate(courseGuid, params) {
  return axios.post(`v3/home-templates/${courseGuid}/clone`, params);
}
